// extracted by mini-css-extract-plugin
export default {"tableContainer":"ReportTable_tableContainer__xFKXy","reportTable":"ReportTable_reportTable__Xe4Ec"};